'use strict';

export function asideMenuInit() {
  // Znajdź element <aside>
  const aside = document.querySelector('.page-content__aside');

  if (aside) {
    // Znajdź wszystkie linki z atrybutem aria-expanded wewnątrz <aside>
    const menuLinks = aside.querySelectorAll('a[aria-expanded]');

    menuLinks.forEach(link => {
      link.addEventListener('click', function (event) {
        // Zatrzymaj domyślne działanie linku
        event.preventDefault();

        const submenu = aside.querySelector(
          `#${link.getAttribute('aria-controls')}`
        );

        if (submenu) {
          // Zmień stan rozwinięcia menu
          const isExpanded = link.getAttribute('aria-expanded') === 'true';
          link.setAttribute('aria-expanded', !isExpanded); // Zmiana stanu aria-expanded

          // Pokaż lub ukryj submenu
          submenu.hidden = isExpanded;
          submenu.setAttribute('aria-hidden', isExpanded);
        }
      });
    });
  }
}
